import type { Team } from '@/common/api/types/teams';

export const isTeamInPortfolio = (team: Team, loopId: number) => team.loopId === loopId;

export const isTeamInNoPortfolio = (team: Team) => team.loopId == null;

export const getPortfolioScopedTeams = (teams: Team[], loopId: number | undefined): Team[] =>
  loopId === undefined
    ? teams
    : teams.filter((team) => isTeamInPortfolio(team, loopId) || isTeamInNoPortfolio(team));
